var map = {
	"./australia": 678,
	"./australia.js": 678,
	"./cricinfo/africa": 579,
	"./cricinfo/africa.js": 579,
	"./cricinfo/australia": 668,
	"./cricinfo/australia.js": 668,
	"./cricinfo/bangladesh": 669,
	"./cricinfo/bangladesh.js": 669,
	"./cricinfo/global": 670,
	"./cricinfo/global.js": 670,
	"./cricinfo/india": 671,
	"./cricinfo/india.js": 671,
	"./cricinfo/newzealand": 672,
	"./cricinfo/newzealand.js": 672,
	"./cricinfo/pakistan": 673,
	"./cricinfo/pakistan.js": 673,
	"./cricinfo/srilanka": 674,
	"./cricinfo/srilanka.js": 674,
	"./cricinfo/taboola": 666,
	"./cricinfo/taboola.js": 666,
	"./cricinfo/unitedkingdom": 675,
	"./cricinfo/unitedkingdom.js": 675,
	"./cricinfo/unitedstates": 676,
	"./cricinfo/unitedstates.js": 676,
	"./en-global": 680,
	"./en-global.js": 680,
	"./india": 681,
	"./india.js": 681,
	"./philippines": 682,
	"./philippines.js": 682,
	"./southafrica": 683,
	"./southafrica.js": 683,
	"./taboola": 679,
	"./taboola.js": 679,
	"./taboolaDefaults": 667,
	"./taboolaDefaults.js": 667,
	"./unitedkingdom": 684,
	"./unitedkingdom.js": 684,
	"./unitedstates": 685,
	"./unitedstates.js": 685
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 677;



//////////////////
// WEBPACK FOOTER
// ../app/lib/utils/editions/config ^\.\/.*$
// module id = 677
// module chunks = 0